// get list of payment methods for the authorized user

import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { PaymentMethod } from './types';

type Query = {
  limit?: number;
  offset?: number;
};

type Response = {
  count: number;
  methods: PaymentMethod[];
};

export default (makeCall: MakeCall) => (query: Query) =>
  makeCall<Response>('GET', `/api/v2/payment/method/pay-in`, { query });
